<script>
  export let className = "";
  export let height = 1;
</script>

<style>
  svg {
    display: block;
  }
</style>

<svg
  class={className}
  height={`${height}em`}
  viewBox="0 0 40 30"
  focusable="false"
  role="img"
  aria-hidden="true">
  <polygon points="0,0 40,0 20,30 " />
</svg>
